import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useChats } from 'shared/hooks/useChats';

import { SendMessageButton } from '../../components/SendMessageButton/SendMessageButton';
import { PopupOwnOfferContainer } from '../../components/popups/own_offer/container';
import { getAgentAvailability, selectOffer, selectUser } from '../../selectors';
import { getAgent } from '../../selectors/newObject/getAgent';
import { selectIsChatsEnabled } from '../../selectors/offerChat';
import { trackSendMessageClick } from '../ChatPopupContainer/tracking';

export const SendMessageButtonContainer = () => {
  const offer = useSelector(selectOffer);
  const agentAvailability = useSelector(getAgentAvailability);
  const agent = useSelector(getAgent);
  const user = useSelector(selectUser);
  const isChatsEnabled = useSelector(selectIsChatsEnabled);
  const isAgentNotAvailable = agentAvailability && !agentAvailability.available;
  const [isOwnOfferPopupOpen, setOwnOfferPopupOpen] = React.useState(false);
  const { handleOpenChat } = useChats();

  const type = isAgentNotAvailable ? 'open_message' : undefined;

  const onClick = () => {
    trackSendMessageClick({ offer, agent, fromGallery: true });

    if (user && user.realtyUserId === offer.userId) {
      setOwnOfferPopupOpen(true);

      return;
    }

    handleOpenChat({ type });
  };

  const ownOfferPopupClose = () => setOwnOfferPopupOpen(false);

  if (!(isChatsEnabled && !offer.dealRentVersion)) {
    return null;
  }

  return (
    <>
      <PopupOwnOfferContainer isOpen={isOwnOfferPopupOpen} onClose={ownOfferPopupClose} />

      <SendMessageButton>
        <Button theme="fill_secondary" size="M" onClick={onClick} fullWidth>
          Написать
        </Button>
      </SendMessageButton>
    </>
  );
};
